export default {
  title: 'Newsletter',
  sections: {
    main: {
      fields: {
        value: {
          title: 'SEU-Newsletter',
          subTitle: 'Aktuelles Branchenwissen direkt ins Postfach: Wir von SEU machen es Ihnen einfach, auf dem Laufenden zu bleiben. Verpassen Sie nichts – wir senden Ihnen unsere Blogbeiträge über Branchenlösungen, Fachwissen und SEU-News direkt zu.',
          text:'Um sicherzustellen, dass Sie unsere Mitteilungen stets erhalten, folgen Sie bitte diesem kurzen Leitfaden:' +
              '<br> <br>1. Melden Sie sich zunächst an und bestätigen Sie Ihre E-Mail-Adresse durch den Link, den wir Ihnen in unserer ersten Nachricht zusenden.' +
              '<br>2. Sollten Sie unsere E-Mail nicht in Ihrem Posteingang finden, schauen Sie bitte in Ihrem Spam-Ordner nach. Falls die E-Mail dort gelandet sein sollte, markieren Sie sie bitte als "Kein Spam".' +
              '<br>3. Falls Sie Google Mail verwenden, schauen Sie bitte im "Promotions"-Tab nach. Sollten Sie dort unsere E-Mail finden, ziehen Sie diese in Ihren Haupt-Posteingang.' +
              '<br>4. Um sicherzustellen, dass Sie unsere Nachrichten stets erhalten, empfehlen wir Ihnen, <span style="font-weight: 600">info@seu.ch</span> zu Ihrem Adressbuch oder Ihrer Kontaktliste hinzuzufügen.' +
              '<br> <br>Bleiben Sie informiert und verpassen Sie keine unserer Updates. Vielen Dank, dass Sie sich für SEU entschieden haben.',
          buttonLabel: 'Jetzt anmelden',
        },
      }
    }
  }
}
